export const additionalChargesTab = {
  loading: "Loading settings…",
  tax: {
    title: "Tax (VAT)",
    tag: "Included in the price",
    description:
      "VAT is already <b>included</b> in your rate prices. Here you only set what percentage is broken out on the receipt and invoice — <b>it is not added to the total</b>.",
    hint: "Empty = the VAT of the assigned billing issuer is used. Applies to direct bookings only.",
  },
  cleaning: {
    title: "Cleaning fee",
    tag: "Fixed",
    description: "Fixed amount per stay. If <b>0</b>, it is not applied.",
    showToGuest: "Show in the booking summary",
  },
  charges: {
    title: "Additional charges",
    summary: "{count} charge configured. | {count} charges configured.",
    summaryEmpty: "Create optional charges (per booking, per person or per night).",
    addButton: "Add charge",
    empty: "No additional charges yet.",
    headers: {
      title: "Title",
      method: "How it's charged",
      value: "Value",
      visible: "Visible",
    },
    titlePlaceholder: "e.g. Tourist tax",
    removeTitle: "Delete",
    hint: "Visible charges are shown as a separate line to the guest at checkout; the rest are added to the total.",
  },
  methods: {
    perStay: "Amount per booking",
    perNight: "Amount per night",
    perPerson: "Amount per person",
    perPersonPerNight: "Amount per person per night",
    percent: "% of the booking total",
  },
  validation: {
    cleaningInvalid: "The cleaning fee must be a valid, positive number.",
    taxRange: "VAT must be between 0 and 100%.",
    chargeTitleRequired: "Each additional charge needs a title.",
    chargeValueInvalid: 'The value of the charge "{title}" is not valid.',
    chargePercentMax: 'The percentage of the charge "{title}" cannot exceed 100%.',
  },
  toasts: {
    saveSuccess: "Additional charges saved successfully.",
    saveError: "Additional charges couldn't be saved.",
  },
};
